import React, { useState } from "react";
import "./style.css";

interface IProps {
  text: string;
  minLengthText: number;
}

const ReadMore: React.FC<IProps> = ({ text, minLengthText }: IProps) => {
  const [readMore, setReadMore] = useState(false);

  const extraContent = (
    <div>
      <p className={"extra-content"}>{text}</p>
    </div>
  );

  const sliceContent = (
    <div>
      <p className={"extra-content"}>{`${text.slice(0, minLengthText)}...`}</p>
    </div>
  );

  const linkName = readMore ? "Czytaj mniej <<" : "Czytaj więcej >>";

  return (
    <React.Fragment>
      {readMore ? extraContent : sliceContent}
      <button className={"read-more-link"} onClick={() => setReadMore(!readMore)}>
        {linkName}
      </button>
    </React.Fragment>
  );
};

export default ReadMore;
